import React from 'react';
import {Picker, List } from 'antd-mobile';
import PropTypes from 'prop-types';
import _ from 'lodash';

const PickerInput = props => (
    <Picker
        data={props.data}
        cols={1}
        okText={'Ok'}
        dismissText={'Annuler'}
        extra={<ExtraLabel extra={props.extra} />}
        value={_.values(_.pick(_.filter(props.data, c => c.value === props.value)[0],'value'))}
        onOk={v => props.onOk(v[0])}
    >
        <List.Item>
            <span className='common' style={{marginLeft: '10px', fontSize: '14px'}}>{props.label}</span>
        </List.Item>
    </Picker>
);

const ExtraLabel = props => <span style={{color: '#B8C0CA', fontFamily: 'fff-equipe', fontSize: '14px', fontWeight: 'normal'}}>{props.extra}</span>

PickerInput.propTypes = {
    data: PropTypes.arrayOf(PropTypes.shape({
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        label: PropTypes.string
    })).isRequired,
    label: PropTypes.string,
    extra: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
    value: PropTypes.string.isRequired,
    onOk: PropTypes.func.isRequired
}

export default PickerInput;
